export const mapEnvTypes: {[key: number]: { id: number, name: string, color: string }} = {
  20: {
    id: 20,
    name: 'inside',
    color: '#FFFFFF' // white
  },
  21: {
    id: 21,
    name: 'wilderness',
    color: '#228B22' // forest_green
  },
  22: {
    id: 22,
    name: 'road',
    color: '#A52A2A' // brown
  },
  23: {
    id: 23,
    name: 'horse',
    color: '#DEB887' // burlywood
  },
  24: {
    id: 24,
    name: 'swamp',
    color: '#9400D3' // dark_violet
  },
  25: {
    id: 25,
    name: 'water',
    color: '#0000FF' // blue
  },
  26: {
    id: 26,
    name: 'drink',
    color: '#66CDAA' // medium_aquamarine
  },
  27: {
    id: 27,
    name: 'weaponsmith',
    color: '#4682B4' // steel_blue
  },
  28: {
    id: 28,
    name: 'armorer',
    color: '#808080' // gray
  },
  29: {
    id: 29,
    name: 'blacksmith',
    color: '#FF8C00' // dark_orange
  },
  30: {
    id: 30,
    name: 'bank',
    color: '#FFD700' // gold
  },
  31: {
    id: 31,
    name: 'stables',
    color: '#800080' // purple
  },
  32: {
    id: 32,
    name: 'rent',
    color: '#008000' // green
  },
  33: {
    id: 33,
    name: 'grocer',
    color: '#FF0000' // red
  },
  34: {
    id: 34,
    name: 'warrior',
    color: '#A0522D' // sienna
  },
  35: {
    id: 35,
    name: 'rogue',
    color: '#2F4F4F' // dark_slate_gray
  },
  36: {
    id: 36,
    name: 'hunter',
    color: '#9ACD32' // yellow_green
  },
  37: {
    id: 37,
    name: 'pk',
    color: '#D3D3D3' // light_gray
  },
  38: {
    id: 38,
    name: 'city',
    color: '#A52A2A' // brown
  },
  39: {
    id: 39,
    name: 'herb',
    color: '#FFFF00' // yellow
  },
  40: {
    id: 40,
    name: 'tailor',
    color: '#FF00FF' // magenta
  },
  41: {
    id: 41,
    name: 'nochannel',
    color: '#808080' // gray
  },
  42: {
    id: 42,
    name: 'portalstone',
    color: '#808080' // gray
  },
  43: {
    id: 43,
    name: 'trees',
    color: '#7CFC00' // lawn_green
  },
  44: {
    id: 44,
    name: 'smob',
    color: '#B22222' // firebrick
  },
  45: {
    id: 45,
    name: 'herbalist',
    color: '#FFFF00' // yellow
  }
};